import { exists } from '@jack-henry/frontend-utils/functions';
import at from 'lodash.at';

/**
 *
 * @param e TextFieldValueChangedEvent or raw search string
 * @param itemsToFilter Array of any values to filter
 * @param keysToSearch Array<string> of keys to compare the value with the search term. Note that a key should be passed with dot notation if you are attempting to search a value in an object EX: 'FromAccount.Number'
 * @returns
 */
export function filterTableResults(
    e: CustomEvent<{ value?: string }> | string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    itemsToFilter: any[],
    keysToSearch: readonly string[]
) {
    const searchTerm = (typeof e === 'string' ? e : e.detail.value || '').trim();
    const items = itemsToFilter ?? [];
    if (searchTerm === '') {
        return items;
    }

    const matchesTerm = (value: string | number): boolean => {
        if (!exists(value)) {
            return false;
        }
        return value.toString().toLowerCase().includes(searchTerm.toLowerCase());
    };

    return items.filter((_, index) =>
        at(itemsToFilter[index], ...keysToSearch).some(value => matchesTerm(value))
    );
}
